import { vuexfireMutations, firebaseAction } from 'vuexfire'
// import { firebaseDB, firebaseStorageRef } from '@/config/firebaseConfig'
import { firebaseDB } from '@/config/firebaseConfig'

const state = {
  orders: {}
}

const mutations = {
  ...vuexfireMutations
}

const actions = {
  bindOrders: firebaseAction(({ bindFirebaseRef }, shopId) =>
    bindFirebaseRef('orders', firebaseDB().ref(`orders/${shopId}`))
  ),
  unbindOrders: firebaseAction(({ unbindFirebaseRef }) => {
    unbindFirebaseRef('orders', true)
  }),
  proceedOrder: async ({ getters }, payload) => {
    const orderId = payload.orderId
    const customerId = payload.customerId
    const newStatus = payload.newStatus
    const status = payload.status
    return firebaseDB().ref(`/orders/${getters.shopId}/${customerId}/${orderId}`).update({
      currentStatus: newStatus,
      status: status
    })
  },
  markAsPaid: async ({ getters }, data) => {
    return firebaseDB().ref(`/orders/${getters.shopId}/${data.customerId}/${data.orderId}`).update({ paid: data.paid })
  }
}

const getters = {
  orders: state => state.orders
}

export default {
  state,
  mutations,
  actions,
  getters
}
